import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import ListVehiclesWaitHappy from './Vehicles';
import AgencyWaitHappy from './Agency';
import DealerWaitHappy from './Dealer';

export const waitHappyRoutes = [
  {'component': <ListVehiclesWaitHappy />, 'path': paths.ListVehiclesWaitHappy},
  {'component': <AgencyWaitHappy />, 'path': paths.AgencyWaitHappy},
  {'component': <DealerWaitHappy />, 'path': paths.DealerWaitHappy},
];
